<script>
import { onMount } from 'svelte';
import { Label, Icon} from '@smui/common';
import Button from '@smui/button';
import Dialog, { Title, Content, Actions } from '@smui/dialog';
import IconButton from '@smui/icon-button';

export let id = "ID"
export let title = "..."
export let subtitle = "Total cycle hire trips for each year by city"
export let subnote = ""
export let mdIcon = "directions_bike"
export let decPlaces = 0
export let units = ""
export let data = {}
export let intro = ""
export let popupInfo = "..."

let openDialog;
let clicked;
let buttoned = 'Nothing yet.';
onMount(async () => {
  console.log("data", data)
});
</script>
<section>

<Dialog
  bind:open="{openDialog}"
  aria-labelledby="simple-title"
  aria-describedby="simple-content"
>
  <!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
  <!-- <Title id="simple-title">Dialog Title</Title> -->
  <Content id="simple-content">{@html popupInfo}</Content>
  <Actions>
    <!-- <IconButton class="material-icons" color="red" on:click={() => true}>close</IconButton> -->
    <Button on:click={() => (openDialog = false)}>
      <Label>Close</Label>
    </Button>
  </Actions>
</Dialog>

  <div class="section-body">
    <h2 class="ioreveal animate__animated" data-anicss="animate__fadeInDown">
      <span class="material-icons">{mdIcon}</span>
      {title}
    </h2>
    <h4>{subtitle}
      <Button on:click={() => openDialog = !openDialog}>
        <Icon class="material-icons">info</Icon>
        <!-- <Label>More info</Label> -->
      </Button>
      {#if (subnote)}
      <span style="font-style: italic; opacity:0.8; font-size: 11px; margin: 8px 0 0 0; display: block">{subnote}</span>
      {/if}
    </h4>

    <div class="row ioreveal animate__animated" data-anicss="animate__fadeInUp">
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"></div>
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
        <div class="year-title-2019">2019</div>
      </div>
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
        <div class="year-title-2020">2020</div>
      </div>
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
        <div class="year-title-2021">2021
        <span style="font-style:italic;font-size:12px">Jan-Mar</span>
        </div>
      </div>
    </div>
    {#each data as provider, i}
    <div class="row ioreveal animate__animated animate__delay-3s" data-anicss="animate__fadeInUp" style="animation-delay: {0.2 * (i+1)}s;">
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
        <div class="provider-name">
        {provider.name}, {provider.city}
        {#if (provider.city === 'Portland')}
        <div style="color:rgba(255,255,255, 0.6);font-style:italic;font-size:12px">2020 Jan-Aug</div>
        {/if}
        </div>
      </div>
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
        <div class="year-title-2019 statistic-num">
        <span
          data-countup="{provider.numparts2019.num}"
          data-countup-decplaces="{provider.data2019 > 999999 ? decPlaces : 0}">0</span>
          <span>{provider.numparts2019.suffix || ''}</span>
          <span class="units">{units}</span>
        </div>
      </div>
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
        <div class="year-title-2020 statistic-num">
        <span
          data-countup="{provider.numparts2020.num}"
          data-countup-decplaces="{provider.data2020 > 999999 ? decPlaces : 0}">0</span>
          <span>{provider.numparts2020.suffix || ''}</span>
          <span class="units">{units}</span>
          {#if provider.arrowUp}
            <div
              title="percentage change against 2019"
              class="ioreveal animate__animated animate__fadeIn animate__delay-3s percent-change-highlight"
              data-anicss="animate__fadeIn"
              style="background-color: rgba(30, 162, 10, 0.8);">
              <Icon class="material-icons" style="font-size:14px; float:right">arrow_upward</Icon>
              <span>{ Math.abs(provider.percentDiff) }%</span>
            </div>
          {:else}
            <div
              title="percentage change against 2019"
              class="ioreveal animate__animated animate__fadeIn animate__delay-3s percent-change-highlight"
              data-anicss="animate__fadeIn"
              style="background-color: rgba(209, 14, 14, 0.8);">
              <Icon class="material-icons" style="font-size:14px; float:right">arrow_downward</Icon>
              <span>{ Math.abs(provider.percentDiff) }%</span>
            </div>
          {/if}
        </div>
      </div>
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
        {#if (provider.city === 'Portland')}
        <div style="font-style:italic; padding:10px 0; opacity:0.6">- NA - </div>
        {:else}
        <div class="year-title-2021 statistic-num">
        <span
          data-countup="{provider.numparts2021.num}"
          data-countup-decplaces="{provider.data2021 > 999999 ? decPlaces : 0}">0</span>
          <span>{provider.numparts2021.suffix || ''}</span>
          <span class="units">{units}</span>
          {#if provider.arrowUp2021}
            <div
              title="percentage change against 2019"
              class="animate__animated animate__fadeIn animate__delay-3s percent-change-highlight"
              data-anicss="animate__fadeIn"
              style="background-color: rgba(30, 162, 10, 0.8);">
              <Icon class="material-icons" style="font-size:14px; float:right">arrow_upward</Icon>
              <span>{ Math.abs(provider.percentDiff2021) }%</span>
            </div>
          {:else}
            <div title="percentage change against 2019"
              class="animate__animated animate__fadeIn animate__delay-3s percent-change-highlight"
              data-anicss="animate__fadeIn"
              style="background-color: rgba(209, 14, 14, 0.8);">
              <Icon class="material-icons" style="font-size:14px; float:right">arrow_downward</Icon>
              <span>{ Math.abs(provider.percentDiff2021) }%</span>
            </div>
          {/if}
        </div>
        {/if}
      </div>
    </div>
    {/each}

    <div class="ioreveal animate__animated animate__delay-3s mt-2" data-anicss="animate__fadeIn" style="animation-delay: 2s;">
      <div class="note"><strong>Note</strong>: % differences are based on 2019 base levels</div>
      <!-- <Button on:click={() => openDialog = !openDialog}>
        <Icon class="material-icons">info</Icon>
        <Label>More info</Label>
      </Button> -->
    </div>

    {#if (intro)}
    <p
      class="mt-3 ioreveal animate__animated animate__delay-3s"
      data-anicss="animate__fadeInUp"
      style="animation-delay: 2s">{@html intro}</p>
    {/if}

    <!-- <i>Stats combined and for each city</i>
    <ul>
      <li>Combined total US trips for 2019 and 2020 (with % change arrow)</li>
      <li>Total trips NYC for 2019 and 2020 (with % change arrow)</li>
      <li>Total trips DC for 2019 and 2020 (with % change arrow)</li>
      <li>Total trips Chicago for 2019 and 2020 (with % change arrow)</li>
      <li>Total trips LA for 2019 and 2020 (with % change arrow)</li>
      <li>Total trips Portland for 2019 and 2020 (with % change arrow)</li>
    </ul>
    Cities shown on map and table with bar charts next to them or with bubble and % change. All animated. -->
  </div>
</section>

<style>
.row {
  /* margin-top: 12px; */
  font-size: 1.2rem;
  padding: 10px 0;
}
.row:nth-child(odd) {
  background-color: rgba(0,0,0,0.1);
}

.units {
  font-size:1rem;
}
.section-body {
  /* max-width: 960px;
  padding: 30px;
  margin: auto; */
  /* margin-left: 200px; */
  /* text-align: left; */
}
.statistic-num {
  font-size: 2.2rem;
}

@media (max-width: 768px) {
  .statistic-num {
    font-size: 1.2rem;
  }
  .row {
    font-size: 1rem;
  }
}
.provider-name {
  margin-top: 8px;
  text-align: left;
}
.arrow-percent {
  padding:2px 4px;
  /* background-color: rgba(255,255,255,0.7); */
  border-radius: 10px;
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
}
.percent-change-highlightNA {
  border-radius:15px;
  color: rgba(255,255,255, 0.9);
  background-color: rgba(9,195,15,0.99);
  /* box-shadow: 4px 4px 4px 4px rgba(0,0,0,0.3); */
  font-size: 12px;
  position: absolute;
  top: -10px;
  right: -10px;
  padding: 3px;
  /* width: 30px; */
  height:25px;
}
.percent-change-highlight {
  border-radius:15px;
  color: rgba(255,255,255, 0.9);
  /* background-color: rgba(30,162,10,0.99); */
  /* box-shadow: 4px 4px 4px 4px rgba(0,0,0,0.3); */
  font-size: 10px;
  position: relative;
  top: -12px;
  right: 12px;
  /* bottom: 0; */
  padding: 6px;
  display: inline-block;
  opacity: 0.9;
  /* width: 30px; */
  /* height:25px; */
}
@media (max-width: 768px) {
  .percent-change-highlight {
    position: static;
  }

}

.percent-change-highlight span {
  /* display: inline-block;
  padding-top: 5px; */
  font-weight: normal;
  float: left;
  padding-top: 3px;
}

/* .arrow-percent-green {
  border: solid 2px rgba(0,120,0,0.5)
}
.arrow-percent-red {
  border: solid 2px rgba(255,10,10,0.5)
} */
</style>